<script setup lang="ts">
import type {
  // StaffMemberCategoryFragment,
  StaffMemberThumbFragment,
} from '#graphql-operations'

interface NewsAuthorProps {
  author: StaffMemberThumbFragment
}

// const props = defineProps<NewsAuthorProps>()
defineProps<NewsAuthorProps>()
const el = useCurrentElement<HTMLElement>()

const isLargeScreen = useMq('lg')
const enabledAnimation = ref(false)
// const categories = computed(() => props.author.staffMemberCategory as StaffMemberCategoryFragment[])

useGsap(() => {
  if (enabledAnimation.value && isLargeScreen.value) {
    gsap.timeline({
      scrollTrigger: {
        trigger: el.value,
        start: 'top 75%',
        toggleActions: 'restart none none reverse',
      },
    })
      .from('.gsap\\:image, .gsap\\:title, .gsap\\:text', {
        autoAlpha: 0,
        y: 8,
        ease: 'power1',
        stagger: {
          amount: 0.2,
          // from: 'center',
        },
      })

    gsap.utils.toArray<HTMLElement>('.gsap\\:text', el.value).forEach((text) => {
      const image = el.value.querySelector('.gsap\\:image') as HTMLElement
      const imageH = image?.offsetHeight ?? 0
      const textH = text.offsetHeight ?? 0
      const offset = (imageH - textH) / 2

      gsap.timeline()
        .to(text, {
          y: offset,
          autoAlpha: 1,
          overwrite: true,
          ease: 'none',
          scrollTrigger: {
            trigger: el.value,
            start: 'top 75%',
            end: 'top 25%',
            scrub: true,
          },
        })
    })
  }
}, { scope: el, dependencies: [isLargeScreen], revertOnUpdate: true })
</script>

<template>
  <Section padded class="blockSpotlight container space-y-6 lg:space-y-10">
    <div class="gsap:title text-center">
      <Text as="h2" :text="`${$t('about')} ${author.title}`" class="typo-serif-2 mb-1" />
      <!-- <Text v-for="category in categories" :key="category!.id" :text="category!.title" class="typo-sans-1 uppercase" /> -->
      <Text as="p" :text="author.role" class="typo-sans-1 uppercase" />
    </div>
    <div class="layout-grid items-start space-y-6 lg:space-y-0" :class="enabledAnimation ? 'items-start' : 'items-center'">
      <div class="gsap:text col-span-full lg:col-span-5">
        <Text v-if="author.textLeft" class="typo-serif-1 text-center space-y-1lh lg:px-25" :html="author.textLeft" />
      </div>
      <div class="gsap:image col-span-4 col-start-2 lg:col-span-2 lg:col-start-auto">
        <CraftMedia v-for="media in author.thumbMedia" :key="media!.id" class="rounded-2 of-hidden" :media :img-props="{ alt: author.title }" />
      </div>
      <div class="gsap:text col-span-full lg:col-span-5">
        <Text v-if="author.textRight" class="typo-serif-1 text-center space-y-1lh lg:px-25" :html="author.textRight" />
      </div>
    </div>
    <div class="flex gap-2 items-center justify-center">
      <ButtonLink :to="author.url" :title="`${$t('more_about')} ${author.title}`" />
    </div>
  </Section>
</template>
